"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = mapStateToProps;
exports.default = exports.PulseWidget = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

require("./PulseWidget.scss");

var _TabList = require("@react/react-spectrum/TabList");

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _Settings = _interopRequireDefault(require("@react/react-spectrum/Icon/Settings"));

var _PulseNotificationsTab = _interopRequireDefault(require("../tabs/PulseNotificationsTab"));

var _PulseAnnouncementsTab = _interopRequireDefault(require("../tabs/PulseAnnouncementsTab"));

var _StatusLight = _interopRequireDefault(require("./StatusLight"));

var _BulkNotificationUpdateService = _interopRequireDefault(require("../../service/BulkNotificationUpdateService"));

var _store = _interopRequireDefault(require("../../store/store"));

var _Toast = require("@react/react-spectrum/Toast");

var NotificationSelectors = _interopRequireWildcard(require("../../store/reducers/NotificationReducer"));

var types = _interopRequireWildcard(require("../../store/actions/actionTypes"));

var _adobeIntlReact = _interopRequireWildcard(require("@adobe/adobe-intl-react"));

var localizationStrings = _interopRequireWildcard(require("./__localization__/PulseWidget"));

var _metrics = _interopRequireDefault(require("@exc/runtime/metrics"));

var _MetricsUtil = _interopRequireDefault(require("../../util/MetricsUtil"));

/*************************************************************************
 ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/

/**
 * PulseWidget which displays notifications and announcements in separate tabs
 */
var PulseWidget =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PulseWidget, _Component);

  function PulseWidget(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PulseWidget);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PulseWidget).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTabChange", function (tabIndex) {
      var activeTabIndex = _this.props.activeTabIndex;

      if (tabIndex == 1) {
        _this.metrics.event("flyout.announcementTab.clicked");
      }

      if (activeTabIndex !== tabIndex) {
        _this.props.dispatch({
          type: types.ACTIVE_TAB_INDEX_CHANGED,
          payload: tabIndex
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderAnnouncementTab", function () {
      return _react.default.createElement(_TabList.Tab, {
        className: "pulse-announcements-tab"
      }, _react.default.createElement("span", null, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
        messageId: "Announcements",
        defaultMessage: "Announcements",
        description: "Announcements Title"
      })), _react.default.createElement(_StatusLight.default, null));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderTabs", function () {
      return _react.default.createElement(_TabList.TabList, {
        onChange: _this.handleTabChange,
        quiet: true,
        selectedIndex: _this.props.activeTabIndex
      }, _react.default.createElement(_TabList.Tab, {
        className: "pulse-notification-tab"
      }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
        messageId: "Notification",
        defaultMessage: "Notifications",
        description: "Notification Title"
      })), _this.renderAnnouncementTab());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderMarkAllAsReadBtn", function () {
      return _react.default.createElement(_Button.default, {
        className: "pulse-button-mark-all-as-read",
        disabled: _this.props.unreadCount == 0,
        variant: "primary",
        quiet: true,
        onClick:
        /*#__PURE__*/
        (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        _regenerator.default.mark(function _callee() {
          var result;
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.metrics.event("flyout.markAllAsReadButton.click");

                  _context.next = 3;
                  return _BulkNotificationUpdateService.default.markAllAsRead();

                case 3:
                  result = _context.sent;

                  if (result) {
                    _store.default.dispatch({
                      type: types.MARK_ALL_NOTIFICATION_AS_READ
                    });
                  }

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
        messageId: "MarkAllAsRead",
        defaultMessage: "Mark all as read",
        description: "Mark all as read"
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getActiveTabByIndex", function (index) {
      switch (index) {
        case 0:
          return '';
          break;

        case 1:
          return 'announcements';
          break;

        default:
          return '';
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderViewAllBtn", function () {
      return _react.default.createElement(_Button.default, {
        className: "pulse-button-view-all",
        variant: "primary",
        quiet: true,
        onClick: function onClick() {
          _this.metrics.event("flyout.viewAllButton.click");

          _this.props.onViewAllClicked(_this.getActiveTabByIndex(_this.props.activeTabIndex));
        }
      }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
        messageId: "ViewAll",
        defaultMessage: "View all",
        description: "View all"
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderWidgetHeader", function () {
      return _react.default.createElement("div", {
        className: "pulse-widget-header"
      }, _react.default.createElement("div", {
        className: "pulse-widget-tabs"
      }, _this.renderTabs()));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderWidgetBody", function () {
      return _react.default.createElement("div", null, _this.props.activeTabIndex === 0 ? _react.default.createElement(_PulseNotificationsTab.default, null) : _react.default.createElement(_PulseAnnouncementsTab.default, null));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderWidgetFooter", function () {
      return _react.default.createElement("div", {
        className: "pulse-widget-footer"
      }, _this.props.activeTabIndex ? null : _this.renderMarkAllAsReadBtn(), _this.renderViewAllBtn());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderNoLinkToast", function () {
      return _react.default.createElement(_Toast.Toast, {
        className: "no-link-toast",
        closable: true,
        onClose: function onClose() {
          return _store.default.dispatch({
            type: types.NOTIFICATION_URL_LINK_VALIDATION,
            payload: true
          });
        }
      }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
        messageId: "NoLinkNotification",
        defaultMessage: "No link available for this notification",
        description: "No Link Notifaction Message"
      }));
    });
    _this.metrics = _metrics.default.create("exc.pulse.components.flyouts.PulseWidget");
    return _this;
  }
  /**
   * Handler to switch tabs
   *
   * @param {number} tabIndex - index of the tab
   */


  (0, _createClass2.default)(PulseWidget, [{
    key: "render",

    /**
     * Parent render method of pulse widget
     *
     * @return {ReactElement} markup representing Pulse Widget
     */
    value: function render() {
      var validLink = this.props.validLink;
      return _react.default.createElement(_adobeIntlReact.default, {
        locale: this.props.locale,
        localeData: localizationStrings
      }, _react.default.createElement("div", {
        className: "pulse-widget-root"
      }, !validLink && this.renderNoLinkToast(), this.renderWidgetHeader(), this.renderWidgetBody(), this.renderWidgetFooter()));
    }
  }]);
  return PulseWidget;
}(_react.Component);

exports.PulseWidget = PulseWidget;

function mapStateToProps(state) {
  return {
    activeTabIndex: NotificationSelectors.getActiveTabIndex(state),
    locale: NotificationSelectors.getLocale(state),
    unreadCount: NotificationSelectors.getUnreadNotificationCount(state),
    validLink: NotificationSelectors.getNotificationLinkValidation(state)
  };
}

var _default = (0, _reactRedux.connect)(mapStateToProps)(PulseWidget);

exports.default = _default;